import reduceReducers from "reduce-reducers";

import { SIDELOADED_BUSINESS_SET } from "constants/actionTypes";

import { defaultInitialState, offlineCrudReducer } from "lib/reducers";
import { deserializeSideLoadedDataSet } from "lib/serializers/sideLoadedDataSets";

const initialState = {
  ...defaultInitialState,
  isUploading: false,
  uploadError: null,
};

const crudReducer = offlineCrudReducer(SIDELOADED_BUSINESS_SET, {
  deserializer: deserializeSideLoadedDataSet,
  // So a FETCH_BULK.RESET restores the upload fields too, rather than dropping
  // them back to the bare slice shape.
  initialState,
});

const uploadReducer = (state = initialState, action) => {
  switch (action.type) {
    case SIDELOADED_BUSINESS_SET.UPLOAD.REQUEST:
      return { ...state, isUploading: true, uploadError: null };
    case SIDELOADED_BUSINESS_SET.UPLOAD.SUCCESS:
      return { ...state, isUploading: false, uploadError: null };
    case SIDELOADED_BUSINESS_SET.UPLOAD.FAILURE:
      return { ...state, isUploading: false, uploadError: action.errorMessage };
    // Only the error - an upload in flight keeps its spinner.
    case SIDELOADED_BUSINESS_SET.UPLOAD.RESET_ERROR:
      return { ...state, uploadError: null };
    default:
      return state;
  }
};

const sideLoadedDataSets = reduceReducers(
  initialState,
  crudReducer,
  uploadReducer,
);

export default sideLoadedDataSets;
